import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";


const EmployeeCost = () => {


    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Employee Cost"))
    }, [])


    const [employeeCostData, setEmployeeCostData] = useState([]);
    const [empOption, setEmpOption] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);

    const columns = {
        EmpCode: { text: "EMP ID", align: "start", visible: true },
        EmpName: { text: "Employee Name", align: "start", visible: true },
        JoiningDate: { text: "Joining Date", align: "center", visible: true },
        Designation: { text: "Designation", align: "start", visible: true },
        Department: { text: "Department", align: "start", visible: true },
        ReportingManager: { text: "Reporting Manager", align: "start", visible: true },
        gross: { text: "Gross Salary", align: "end", visible: true },
        CTC: { text: "CTC", align: "end", visible: true },

    };

    useEffect(() => {
        fetchEmployeeCost();
    }, []);


    const [apiStatus, setApiStatus] = useState(undefined)

    const fetchEmployeeCost = async () => {
        setApiStatus(undefined)
        try {
            const response = await GetServiceCaller(`${API_URL}rom-report/8?P_JobDescriptionID=${0}`);
            setApiStatus(response?.status)
            if (response.status === 200) {
                const cleanedData = response?.data?.header;
                setEmployeeCostData(cleanedData);

                const empOptions = response?.data?.employee.map((ele, index) => ({
                    value: ele?.value,
                    label: ele?.text,
                }))
                setEmpOption(empOptions);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Employee Cost. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Employee Cost:", error);
        }
    };


    const formDatas = [
        {
            name: "Employee",
            type: "Select",
            options: [...empOption],
        },
    ];

    const handleGetData = async () => {
        setApiStatus(undefined)
        try {
            const response = await GetServiceCaller(
                `${API_URL}rom-report/8?P_JobDescriptionID=${filterFormData.find((o) => o.label === "Employee")
                    ? filterFormData.find((o) => o.label === "Employee").value
                    : 0}`
            );
            setApiStatus(response?.status)
            if (response.status === 200) {
                const cleanedData = response?.data?.header;
                setEmployeeCostData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch partnerMaster. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching PartnerMaster:", error);
        }
    };

    const [filterFormData, setFilterData] = useState([]);

    const handleChange = (e, name) => {
        setFilterData((prevFormData) => {
            // Check if the label already exists
            const existingLabelIndex = prevFormData.findIndex(
                (item) => item.label === name
            );

            // If the label exists, update its value
            if (existingLabelIndex !== -1) {
                const updatedFormData = prevFormData.map((item, index) =>
                    index === existingLabelIndex
                        ? { ...item, value: e.value !== undefined ? e.value : e }
                        : item
                );
                return updatedFormData;
            } else {
                // If the label doesn't exist, add a new label-value pair
                return [
                    ...prevFormData,
                    {
                        label: name,
                        value: e.value !== undefined ? e.value : e, // Assuming e is an event object
                    },
                ];
            }
        });
    };


    const handleReset = () => {
        setFilterData([])
        fetchEmployeeCost()
    }

    return (
        <>

            <div className="container-fluid" id="skill_section">
               <div className="container-fluid" id="skill-table-area">
                    <div className="row mt-2">
                        <Dynamic_PR_table
                            data={employeeCostData}
                            columns={columns}
                            itemsPerPage={8}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            showIcon1={true}
                            showIcon2={false}
                            isSrNoRequired={true}
                            isActionRequired={false}
                            isAddNewBtnRequired={false}
                            showIcon3={false}
                            showIcon4={true}
                            isRequiredStatus={true}
                            isApiStatus={apiStatus}
                            handleReset={handleReset}
                            isSorting={true}
                            showIcon5={false}
                            formDatas={formDatas}
                            filterFormData={filterFormData}
                            handleGetData={handleGetData}
                            isFilterRequired={true}
                            handleChange={handleChange}
                            // handleIcon1={handleEdit}
                            // handleAddNew={handleAddNewPartner}
                            // handleIcon4={handleAddSubContractor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i class="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon2: <i class="bi bi-trash-fill icons"></i>,
                                Icon3: <i class="bi bi-eye-fill icons"></i>,
                                Icon4: <i class="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>
            </div>

        </>
    )
}

export default EmployeeCost;